export const notificationConstants = {
  NOTIFICATION_LIST_REQUEST: "NOTIFICATION_LIST_REQUEST",
  NOTIFICATION_LIST_COMPLETE: "NOTIFICATION_LIST_COMPLETE",
  NOTIFICATION_LIST_ERROR: "NOTIFICATION_LIST_ERROR",
  NOTIFICATION_LIST_CLEAR: "NOTIFICATION_LIST_CLEAR",

  NOTIFICATION_LANDING_TYPE: "OTHER",
  NOTIFICATION_SET_TO_ZERO: "Y",

  NOTIFICATION_DETAIL_REQUEST: "NOTIFICATION_DETAIL_REQUEST",
  NOTIFICATION_DETAIL_COMPLETE: "NOTIFICATION_DETAIL_COMPLETE",
  NOTIFICATION_DETAIL_ERROR: "NOTIFICATION_DETAIL_ERROR",

  SET_NOTIFICATION_DETAIL_CLEAR: "SET_NOTIFICATION_DETAIL_CLEAR",

  CLEAR_NOTIFICATION_DETAIL_ERROR: "CLEAR_NOTIFICATION_DETAIL_ERROR",

  NOTIFICATION_UPDATE_REQUEST: "NOTIFICATION_UPDATE_REQUEST",
  NOTIFICATION_UPDATE_COMPLETE: "NOTIFICATION_UPDATE_COMPLETE",
  NOTIFICATION_UPDATE_ERROR: "NOTIFICATION_UPDATE_ERROR",

  NOTIFICATION_IS_READ_TRUE: "Y",
  NOTIFICATION_IS_READ_FALSE: "N",
  NOTIFICATION_IS_DELETED_TRUE: "Y",
  NOTIFICATION_IS_DELETED_FALSE: "N",
  NOTIFICATION_IS_MARK_ALL_AS_READ: "Y",

  NOTIFICATION_UNREAD_COUNT_REQUEST: "NOTIFICATION_UNREAD_COUNT_REQUEST",
  NOTIFICATION_UNREAD_COUNT_COMPLETE: "NOTIFICATION_UNREAD_COUNT_COMPLETE",
  NOTIFICATION_UNREAD_COUNT_ERROR: "NOTIFICATION_UNREAD_COUNT_ERROR",

  NOTIFICATION_LINK_TYPE_EXTERNAL_WEB_LINK: "EXTERNAL_WEB_LINK",
  NOTIFICATION_LINK_TYPE_IN_APP_LOCATION: "IN_APP_LOCATION",
  NOTIFICATION_LINK_TYPE_NEW_DETAIL_SCREEN: "NEW_DETAIL_SCREEN",
  NOTIFICATION_LINK_TYPE_BIRTHDAY_REMINDER: "BIRTHDAY_REMINDER",
  NOTIFICATION_DETAIL_NEW_TAB: "_blank",

  NOTIFICATION_READ: "read",
  NOTIFICATION_UNREAD: "unread",

  NOTIFICATION_UNREAD_COUNT_EXCEED: "9+",
  NOTIFICATION_MAX_COUNT: "9",

  SET_IS_PAGINATING_NOTIFICATIONS: "SET_IS_PAGINATING_NOTIFICATIONS",
};

export const inAppRouteMap = {
  TRANSACTION_HISTORY: "/app/history",
  MY_PROFILE: "/app/profile",
  LANDING_PAGE: "/app/dashboard",
  FUND_TRANSFER: "/app/fund-transfer",
  CARDS_SCREEN: "/app/credit-cards-bill-settle",
  FAVOURITES_SCREEN: "/app/favourites",
  CASA: "/app/accounts",
  SETTLE_CARD_SCREEN: "/app/settle-card",
  SETTINGS: "/app/settings",
  BILL_PAYMENT: "/app/bill-payments",
  CARDS: "/app/cards",
};
